import { render, staticRenderFns } from "./rightContent.vue?vue&type=template&id=24b546fe"
import script from "./rightContent.vue?vue&type=script&lang=js"
export * from "./rightContent.vue?vue&type=script&lang=js"
import style0 from "./rightContent.vue?vue&type=style&index=0&id=24b546fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports